module.exports = __webpack_public_path__ + "static/media/bgPublic.73b9d320.jpg";